import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import { Toaster } from "./components/ui/sonner";
import { SpeedInsights } from "@vercel/speed-insights/react";

// Pages
import Home from "./pages/Home";
import Context from "./pages/Context";
import Construction from "./pages/Construction";
import Industries from "./pages/Industries";
import Legislation from "./pages/Legislation";
import Microfactory from "./pages/Microfactory";
import Evolution from "./pages/Evolution";
import Conclusion from "./pages/Conclusion";
import Sources from "./pages/Sources";

function AppRoutes() {
  return (
    <Routes>
      {/* Public Routes - All pages freely accessible */}
      <Route path="/" element={<Home />} />
      <Route path="/context" element={<Context />} />
      <Route path="/construction" element={<Construction />} />
      <Route path="/industries" element={<Industries />} />
      <Route path="/legislation" element={<Legislation />} />
      <Route path="/microfactory" element={<Microfactory />} />
      <Route path="/evolution" element={<Evolution />} />
      <Route path="/conclusion" element={<Conclusion />} />
      <Route path="/sources" element={<Sources />} />
      
      {/* Catch all - redirect to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <AppRoutes />
          <Toaster position="top-right" />
          <SpeedInsights />
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
